import styled, { css } from 'react-emotion'

import * as React from 'react'
import { Column } from './Box'
import { colors, patterns, layouts, desktop } from './styleguide'

const sizeMap = {
  hero: '100vh',
  large: '80vh',
  medium: '60vh',
  small: '20vh',
}
const minSizeMap = {
  large: '800px',
  medium: '600px',
  small: '200px',
}

const Section = styled(Column)`
  ${props =>
    desktop(
      css`
        height: ${sizeMap[props.size] || '80vh'};
      `
    )}
  min-height: ${props => minSizeMap[props.size] || '800px'};
  position: relative;
  ${layouts.content};
`

const Background = styled.div`
  ${props => (props.patterned ? patterns.dots : '')};
  background-color: ${props =>
    props.black
      ? colors.darkGray
      : props.gray
        ? colors.lightGray
        : props.secondary
          ? colors.secondary
          : props.blue ? colors.darkBlue : colors.white};
  width: 100%;
  overflow: hidden;
`

export default ({
  children,
  size,
  patterned,
  secondary,
  black,
  gray,
  blue,
  align,
  justify,
  className,
}) => {
  return (
    <Background
      patterned={patterned}
      secondary={secondary}
      black={black}
      gray={gray}
      className={className}
      blue={blue}>
      <Section size={size} align={align} justify={justify}>
        {children}
      </Section>
    </Background>
  )
}



// WEBPACK FOOTER //
// ../styleguide/src/Layout.jsx